import React from 'react';
import { useTranslation } from 'react-i18next';

interface AddressSelectionPromptProps {
  showManualAddressPrompt: boolean;
  onSelectAddress: () => void;
}

export const AddressSelectionPrompt: React.FC<AddressSelectionPromptProps> = ({
  showManualAddressPrompt,
  onSelectAddress
}) => {
  const { t } = useTranslation();
  
  if (!showManualAddressPrompt) return null;
  
  return (
    <div className="fixed bottom-20 inset-x-0 flex justify-center z-[51]">
      <div className="bg-yellow-50 border border-yellow-200 shadow-md rounded-lg p-4 mx-4 max-w-md flex flex-col items-center">
        <p className="text-yellow-800 text-sm mb-3">
          {t('subscription.addressSelection.prompt')}
        </p>
        <button 
          className="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-4 rounded-full text-sm"
          onClick={onSelectAddress}
        >
          {t('subscription.addressSelection.selectButton')}
        </button>
      </div>
    </div>
  );
}; 